import { useState, useMemo } from 'react';
import { Box, CircularProgress } from '@mui/material';
import _ from 'lodash';
import EmptyCard from '../../../components/ui/EmptyCard';
import { useGetRewardList } from '../../../hooks/useReward';
import { useRewardStore } from '../../../stores/rewardStore';
import RewardItem from './RewardItem';
import RewardSearch from './RewardSearch';

const RewardList = () => {
  const filters = useRewardStore((state) => state.filters);

  const [search, setSearch] = useState('');
  const [sorting, setSorting] = useState('min-max');

  const { data: rewardData, isLoading: isLoadingReward } = useGetRewardList({
    sort_col: 'point',
    sort_value: true,
  });

  const filterListReward = useMemo(() => {
    const listReward = rewardData?.Data?.data || [];
    let newListReward = [...listReward];

    if (filters.length > 0) {
      newListReward = newListReward.filter((item) => filters.includes(item.category));
    }

    if (search) {
      newListReward = newListReward.filter((item) => {
        return (
          item.name.toLowerCase().includes(search.toLowerCase()) ||
          item.point.toString().includes(search)
        );
      });
    }

    if (sorting === 'min-max') {
      newListReward = _.orderBy(newListReward, ['point'], 'asc');
    } else {
      newListReward = _.orderBy(newListReward, ['point'], 'desc');
    }

    return newListReward;
  }, [filters, search, sorting, rewardData]);

  const renderListReward = (list) => {
    if (list.length === 0) {
      return <EmptyCard text="ไม่พบของรางวัล" />;
    }

    return list.map((reward) => {
      return (
        <RewardItem
          key={reward?._id}
          id={reward?._id}
          images={reward?.image}
          point={reward?.point}
          name={reward?.name}
          detail={reward?.detail}
          unit={reward?.unit}
          quantity={reward?.quantity}
        />
      );
    });
  };

  return (
    <>
      <Box p={2.5} display="flex" flexDirection="column" gap={2}>
        <RewardSearch
          value={search}
          setSearch={setSearch}
          onSortingChange={(e) => setSorting(e.target.value)}
          sorting={sorting}
        />
        <Box
          sx={(theme) => ({
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            [theme.breakpoints.up('sm')]: {
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'space-between',
              '& a': {
                width: '48.5%',
              },
            },
          })}
        >
          {isLoadingReward && (
            <CircularProgress thickness={5} sx={{ display: 'block', margin: '20px auto' }} />
          )}
          {!isLoadingReward && renderListReward(filterListReward)}
        </Box>
      </Box>
    </>
  );
};

export default RewardList;
